export const ACCESS_TOKEN_COOKIE_NAME = 'lk_access_token';
